import axiosInstance from '../services/AxiosInstance';

export function getFurnishingStatus(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`furnishing-status?pageNum=${pageNum}&pageSize=${pageSize}&search=${searchTerm}`);
}

export function deleteFurnishingStatus(id) {
    return axiosInstance.delete(`furnishing-status/${id}`);
}

export function createFurnishingStatus(id) {
    return axiosInstance.post(`furnishing-status`,id);
}

export function updateFurnishingStatus(id, data) {
    return axiosInstance.put(`furnishing-status/${id}`,data);
}
